<button type="button" (click)="getReport()" >Run Audit Report</button>
<a #donwloadCsvLink></a>